module.exports = __webpack_public_path__ + "static/media/wine.0e848367.jpg";